"use client"

import { usePathname, useSearchParams } from "next/navigation"
import { useLayoutEffect } from "react"

import { scrollToTopIfArrived } from "../../../instrumentation-client"

export function NavigationScroll() {
  // Subscribe to route commits, including query-only changes such as the two contact forms.
  usePathname()
  useSearchParams()
  useLayoutEffect(scrollToTopIfArrived)
  return null
}
